import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class HttpCERS {

    private currentEnv = 'prod';

    get base(): string {
        return this.config[this.currentEnv].base;
    }

    set base(base) {
        this.config[this.currentEnv].base = base;
    }

    get service(): string {
        return this.config[this.currentEnv].service;
    }

    set service(service) {
        this.config[this.currentEnv].service = service;
    }

    get uploadBase(): string {
		return this.config[this.currentEnv].uploadBase;
	}

	set uploadBase(uploadBase) {
		this.config[this.currentEnv].uploadBase = uploadBase;
	}

    private config = {
        local: {
            base : 'http://localhost:8244/',
            uploadBase : 'http://localhost:8244/',
            service: ''
        },
        hml: {
            base: 'https://apigateway.hml.cers.com.br/api',
            uploadBase: "https://apigateway.hml.cers.com.br/zuul/api",
            service: ''
        },
        prod: {
            base: 'https://apigateway-lulu.cers.com.br/api',
            uploadBase: "https://apigateway-lulu.cers.com.br/zuul/api",
            service: ''
        },
        binario: {
            base: 'http://45.225.25.119/api',
            uploadBase: 'http://45.225.25.119/api',
            service: ''
        }

    };

    constructor(public http: HttpClient) { }

    get(path: string, params: any = {}, collection: object = null) {
        return this.request('get', path, params, collection);
    }

    delete(path: string, params: any = {}, collection: object = null) {
        return this.request('delete', path, params, collection);
    }

    post(path: string, params: any = {}, collection: object = null) {
        return this.request('post', path, params, collection);
    }

    put(path: string, params: any = {}, collection: object = null) {
        return this.request('put', path, params, collection);
    }

    patch(path: string) {
        return this.request('patch', path);
    }

    request(method: string = 'get', path: string = '', params: any = {}, collection: any = null) {
        // Check if collection is filled with something
        if (collection != null) {
            const isList = collection.length !== undefined;
            if (!isList || (isList && collection[0] !== undefined)) {
                return of(collection);
            }
        }

        // Check if request method is valid
        if ( !this.http[method] ) {
            console.error(`The 'method' parameter has to be 'get', 'delete', 'put' or 'post'. '${method}' is unknown.`);
            return;
        }

        // Make the request
        const url = `${this.base}${this.service}${path}`;
        return this.http[method](url, this.setupParams(params, method));
    }

    setContext(context, customBasePath?: string): HttpCERS {
        const clone = new HttpCERS(this.http);
        clone.service = context;

        if (customBasePath) {
            clone.base = customBasePath;
        }

        return clone;
    }

    setLocalContext(context, customBasePath?: string): HttpCERS {

        const oldEnv = this.currentEnv;

        this.setEnv('local');

        this.service = context;

        if (customBasePath) {
            this.base = customBasePath;
        }

        this.setEnv(oldEnv);

        return this;
    }

    setBinarioContext(context, customBasePath?: string): HttpCERS {

        const oldEnv = this.currentEnv;

        this.setEnv('binario');

        this.service = context;

        if (customBasePath) {
            this.base = customBasePath;
        }

        this.setEnv(oldEnv);

        return this;
    }

    setHmlContext(context, customBasePath?: string): HttpCERS {

        const oldEnv = this.currentEnv;

        this.setEnv('hml');

        this.service = context;

        if (customBasePath) {
            this.base = customBasePath;
        }

        this.setEnv(oldEnv);

        return this;
    }

    private setupParams(params: any = {}, method: string = 'get') {
        if (params == null) { return {}; }

        if (['get', 'delete'].includes(method)) {
            return { params };
        }

        return params;
    }

    setEnv(env) {
        this.currentEnv = env;
    }

    getEnv() {
        return this.currentEnv;
    }

    postFile(path, fileToUpload: File): Observable<any> {
      const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});

      const endpoint = `${this.uploadBase}${this.service}${path}`;
      const formData: FormData = new FormData();
      formData.append('file', fileToUpload);
      // return this.http.post(endpoint, formData, { headers });
      return this.http.post<any>(endpoint, formData).pipe(map((event) => {
        switch (event.type) {

          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', message: progress };

          case HttpEventType.Response:
            return event.body;
          default:
            return `Unhandled event: ${event.type}`;
        }
      }));
  }

}
